import p5 from 'p5';

let theta = [ // 開始角度
  0.0,
  0.0,
  0.0,
]
let dx; // Value for incrementing x
let values; // Using an array to store height values for the wave
let runningMeanLength = 1;
let noise = 0.01; // 変化係数
let posX = 100;
let ampScale = 1;
let noisemode = false;
let lineProps = [
  {
    seed: 23,
    period: 600,
    spacing: 50,
    amp: 40,
    rgb: [110, 164, 193],
    weight: 2,
    delta: 0.04,
  },
]

const sketch = (s) => {

  const keyAnimation = document.getElementById('keyAnimation');
  // 画面がリサイズされた時はカンバスもリサイズさせる
  s.windowResized = () => {
    //keyAnimation.style.height = document.body.clientHeight + 'px';
    s.resizeCanvas(keyAnimation.clientWidth, keyAnimation.clientHeight);
  }
  s.windowResized();

  // 準備関数
  s.setup = () => {
    s.createCanvas(keyAnimation.clientWidth, keyAnimation.clientHeight).parent('keyAnimation');
    values = new Array();

    const mediaQuery = window.matchMedia('(max-width: 1159.8px)');
    const mqlistener = () => {
      if(mediaQuery.matches) {
        ampScale = 0.5;
        posX = 30;
      } else {
        ampScale = 1;
        posX = 100;
      }
    }
    mediaQuery.addEventListener('change', mqlistener);
    mqlistener()

    const imgs = document.querySelectorAll('img');
    if(imgs.length) {
      imgs.forEach(elem => {
        elem.addEventListener('load', () => {
          s.windowResized();
        })
      })
    }
  }

  // 描画関数
  s.draw = () => {
    s.clear();
    s.frameRate(30);
    if(noisemode && noise <= 1.0) {
      noise += (1 - noise) / 15;
    } else {
      noise = 0.01;
    }
    renderWave();
  }

  const calcWave = ({spacing, amp, delta}) => {
    // 角の変化量
    theta[0] += delta;
    theta[1] -= delta;
    theta[2] -= delta/2;

    // For every x value, calculate a y value with sine function
    let x = [
      theta[0],
      theta[1],
      theta[2],
    ];
    // s.randomSeed(seed)
    values.length = Math.ceil(s.height / spacing ) * 2; // 十分な長さを用意する
    for (let i = 0; i < values.length; i++) {
      const wave1 = s.sin(0.4*x[0]) * 1;
      const wave2 = s.sin(1.1*x[1]) * (0.45 + noise);
      const wave3 = s.sin(3.7*x[2]) * (0.01 + noise) ;
      values[i] = (wave1*1 + wave2*1 + wave3*1) * amp * ampScale;
      x[0] += dx;
      x[1] += dx;
      x[2] += dx;
    }
  }

  const renderWave = () => {
    s.noFill();
    // s.fill('rgba( 220,240,255, 0.5)');
    lineProps.forEach((line) => {
      dx = (s.TWO_PI / line.period) * line.spacing;
      s.stroke(...line.rgb);
      s.strokeWeight(line.weight);
      s.beginShape();
      // s.curveVertex(s.width + 10, -10);
      calcWave(line);
      for (let x = runningMeanLength; x < values.length; x++) {
        // s.curveVertex(s.width - posX + runningMean(runningMeanLength, values, x), (x-runningMeanLength-1) * line.spacing);
        s.curveVertex(s.width - posX + values[x], (x-runningMeanLength-1) * line.spacing);
      }
      // s.curveVertex(s.width + 10, s.height + 10);
      // s.endShape(s.CLOSE);
      s.endShape();
    })
  }

  // 移動平均を求める
  // const runningMean = (len, arr, idx) => {
  //   let acc = 0;
  //   for(let i = len-1; i>=0; i--) {
  //     acc += arr[idx - i];
  //   }
  //   return acc/len;
  // }
}

// 実行
window.addEventListener('load', () => {
  new p5(sketch);
})

/**
 * 時間をかけて再帰的に数値を0まで数値を減らす
 * @param scale ステップの最大数
 * @param left 残りステップ数
 * @param delay ステップ実行間のディレイ
 */
// function fadeOutRecursive(scale, left, delay) {
//   ifnoise <= 0) return;
//  noise = left/scale;
//   if(left > 0) {
//     window.setTimeout(()=>{fadeOutRecursive(scale, --left, delay)}, delay);
//   }
// }

/**
 * ノイズモードをオンにする
 */
export function emphasisEffect() {
  document.body.classList.remove('is-unfade');
  document.body.classList.add('is-fade');
  noisemode = true;
}

/**
 * ノイズモードをオフにする
 */
export function unEffect() {
  document.body.classList.add('is-unfade');
  document.body.classList.remove('is-fade');
  noisemode = false;
}




// WEBPACK FOOTER //
// ./scripts/modules/_keyAnimation.js